export const REGISTER_FIELD_CHANGE = 'COST_CENTERS/REGISTER_FIELD_CHANGE';
export const SET_COST_CENTER = 'COST_CENTERS/SET_COST_CENTER';
export const HANDLE_SEARCH = 'COST_CENTERS/HANDLE_SEARCH';
export const HANDLE_PAGINATION = 'COST_CENTERS/HANDLE_PAGINATION';
export const LOADING_INFORMATIONS = 'COST_CENTERS/LOADING_INFORMATIONS';
export const CLEAR_COST_CENTERS = 'COST_CENTERS/CLEAR_COST_CENTERS';
export const HANDLE_REGISTRATION = 'COST_CENTERS/HANDLE_REGISTRATION';
export const HANDLE_UPDATE = 'COST_CENTERS/HANDLE_UPDATE';
export const CLEAR_REGISTRATION = 'COST_CENTERS/CLEAR_REGISTRATION';
